// extracted by mini-css-extract-plugin
export default {"login":"Login_login__Vw+bb","actions":"Login_actions__xKZWH"};